import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { ensureNamespaceLoaded } from "../../i18n/lazyNamespaces";
import { TeamTypingProvider } from "../../context/TeamTypingContext";
import { useAuthContext } from "../../context/AuthContext";
import TeamPage from "../Team";

const TeamPopup = () => {
  const { userData } = useAuthContext();

  useEffect(() => {
    void ensureNamespaceLoaded("team");
    void ensureNamespaceLoaded("teamTasks");
  }, []);

  return (
    <TeamTypingProvider currentUserId={userData?.id}>
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          bgcolor: "background.default",
        }}
      >
        <TeamPage basePath="/popup-equipe" standalone />
      </Box>
    </TeamTypingProvider>
  );
};

export default TeamPopup;
